<div class="text-center">Logging out, please wait...</div>
<div class="spinner">
  <img
    class="loader-img"
    alt="Loading..."
    src="./assets/images/CES_HR_Circle_Mini.png"
  />
</div>
